import React from 'react';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { CopyableText, SummarySectionV2 } from '@css-xp/base';

export const NextPriceEstimateSection = ({ entitlement }: { entitlement: EntitlementDetails }) => {
  return (
    <SummarySectionV2.SummaryGridCalloutItem testId="summary-next-price-estimate">
      <div className="billing-plan billing-cycle title-height">
        <label>Next price estimate</label>
        <div className="entitlement-details-column">
          {entitlement.nextBillEstimate ? (
            <CopyableText>
              <span>
                {entitlement.nextBillEstimate.currency}{' '}
                {parseFloat(
                  new Intl.NumberFormat('en-US', { useGrouping: false }).format(entitlement.nextBillEstimate.total ?? 0)
                ).toFixed(2)}
              </span>
            </CopyableText>
          ) : (
            <span className="data-unavailable"> N/A </span>
          )}
        </div>
      </div>
    </SummarySectionV2.SummaryGridCalloutItem>
  );
};
